export default class GeolocalizacaoFotoConstant {
    static LOCALIZACAO = {
        accuracy: null,
        geolocationStatus: null,
        latitude: null,
        longitude: null
    }
}